<!-- //-----------------------------------------------------------------------
// <copyright file="login.component.html" company="LGT India">
//     Author: vanaraj  
//     Copyright (c) LGT India. All rights reserved.
// </copyright>
//----------------------------------------------------------------------- -->
<section class="login-block">
  <div class="login-text">
    <div class="img-align">
      <img src="../../assets/icons/lgtLogo.png" alt="Image" />
    </div>
    <div class="button-submit">
      <button
        type="submit"
        class="btn-login"
        value="Login"
        (click)="this.app.login()"
      >
        Login
      </button>
    </div>
    </div>
</section>
